import { ButtonStyled } from "theme/common/Button.styled"
import ContentDetailOrderActionsStyled from "theme/common/ContentDetailOrderActions.styled"
import { IconCheck } from "theme/common/Icon.styled"
import { IDeliveryAction } from "interfaces/IShippingGroupAction"

const DeliveryAction = ({ loadingDelivery, onClickDeliveryOrder }: IDeliveryAction) => {
  return (
    <ContentDetailOrderActionsStyled>
      <ButtonStyled
        variant="primary"
        loadingButton={loadingDelivery}
        disabled={loadingDelivery}
        onClick={onClickDeliveryOrder}
      >
        <IconCheck />
        <span>Despachar orden</span>
      </ButtonStyled>
    </ContentDetailOrderActionsStyled>
  )
}

export default DeliveryAction
